// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2j35A","messages":"Chat_messages__Jy4Pj","dateDivider":"Chat_dateDivider__1-ptq"};